import { matrixClient } from "./client";
import { matrixRoom } from "./room/";
import { matrixUser } from "./user";

async function init(){
    await matrixClient.init();
    await matrixUser.init();
    await matrixRoom.init();
}
export const matrixInit = {
    init
}